import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';



const Footer = () => {
  return (
    <footer className="mt-auto py-3 text-center" style={{ backgroundColor: 'white' }}>
      <Container>
        <Row>
          <Col className="text-center">
            <span>© 2026 Inorite Ltd - All rights reserved. Company No. 15762027</span>
            <br />
            <span>This website contains public sector information licensed under the Open Government Licence v3.0.</span>
          </Col>
        </Row>
        <Row>
          <Col className="text-center">
            <Link to="/privacy" style={{ marginLeft: '5px' }}>Privacy Policy </Link>
            <Link to="/terms" style={{ marginLeft: '5px' }}>Terms and Conditions</Link>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
